module.exports = __webpack_public_path__ + "static/media/logo.d5b815e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/MaintenancePage/logo.jpg
// module id = 242
// module chunks = 0